export const thumb = (url: string, width: number, height: number) => {
    const parts = url.split('.');
    parts.splice(-1, 0, `${width}x${height}`);

    return parts.join('.');
}
